import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'contactInformation.title',
    defaultMessage: 'Contact',
    description: 'Title of the contact section',
  },
  personalInformation: {
    id: 'contactInformation.personalInformation',
    defaultMessage: 'Personal information',
    description: 'Title of the personal information in the contact section',
  },
  phoneNumber: {
    id: 'contactInformation.phoneNumber',
    defaultMessage: 'Phone number',
    description: 'Title of the phone number in the contact section',
  },
  vatNumber: {
    id: 'contactInformation.vatNumber',
    defaultMessage: 'VAT number',
    description: 'Title of the vat number in the contact section',
  },
  organisation: {
    id: 'contactInformation.organisation',
    defaultMessage: 'Organisation',
    description: 'Title of the organisation in the contact section',
  },
  emptyMessage: {
    id: 'contactInformation.emptyMessage',
    defaultMessage: 'No contact information',
    description: 'Empty message of the contact section',
  },
};

export default defineMessages(translations);
